const moneda = '$';

export function formatearMoneda(valor) {
    if (valor === null || valor === undefined) return '';
    const soloNumeros = String(valor).replace(/[^\d]/g, '');
    if (soloNumeros === '') return '';
    return soloNumeros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function parsearMoneda(valor) {
    if (valor === null || valor === undefined) return '';
    return String(valor).replace(/\./g, '');
}

export default moneda;
